module.exports = __webpack_public_path__ + "img/timer.0bfa34b3.svg";